// Available Times
export const SET_AVAILABLE_TIMES = 'SET_AVAILABLE_TIMES';
export const CLEAR_AVAILABLE_TIMES = 'CLEAR_AVAILABLE_TIMES';



// WEBPACK FOOTER //
// ./src/store/reducers/availableTimes/actionTypes.js